var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineLantern2Nm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: -2310,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-382 2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: -2310,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: -1912,
    width: 1571,
    height: 1570,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.42-627.624C1071.26-624.741 780.998-910.326 778.116-1265.49 775.234-1620.66 1060.82-1910.92 1415.99-1913.8 1418.15-1913.82 1420.32-1913.83 1422.49-1913.82L1422.08-1706.96C1181.15-1707.44 985.442-1512.52 984.96-1271.59 984.477-1030.65 1179.4-834.948 1420.33-834.466 1421.8-834.463 1423.28-834.468 1424.75-834.48Z",
    fill: "#FCEA1E",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineLantern2Nm);
export default __webpack_public_path__ + "static/media/MarineLantern2NM.8043281aede7d30ead3d73138b285202.svg";
export { ForwardRef as ReactComponent };